
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_subdomains/senzacni/ceska-ves",
      function () {
        return require("private-next-pages/_subdomains/senzacni/ceska-ves.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_subdomains/senzacni/ceska-ves"])
      });
    }
  